import { createSelector } from 'reselect'

export const getSurvey = (state) => state.mars.survey

export const isResponseError = createSelector([getSurvey], (survey) => survey.responseError)

export const isResponseOK = createSelector([getSurvey], (survey) => survey.responseOK)
